import React from 'react';
import { Star, Zap, Crown, Heart } from 'lucide-react';

const FanLoyaltyBadge = ({ tier = "fan", size = "sm" }) => {
  const configs = {
    top: {
      label: "Top 1% Fan",
      icon: Crown,
      bg: "bg-amber-400",
      text: "text-amber-900 shadow-amber-200",
    },
    super: {
      label: "Super Fan",
      icon: Zap,
      bg: "bg-purple-500",
      text: "text-white shadow-purple-200",
    },
    fan: {
      label: "Fan",
      icon: Heart,
      bg: "bg-pink-100",
      text: "text-pink-600 shadow-pink-50",
    }
  };

  const config = configs[tier] || configs.fan;
  const Icon = config.icon || Star;

  const sizeClasses = {
    xs: "px-1 py-0.5 text-[8px] gap-0.5",
    sm: "px-2 py-1 text-[10px] gap-1",
    md: "px-3 py-1.5 text-xs gap-1.5"
  };

  return (
    <div className={`inline-flex items-center font-black uppercase tracking-tighter rounded-full shadow-sm hover:neon-glow transition-all cursor-default ${config.bg} ${config.text} ${sizeClasses[size]}`}>
      <Icon size={size === 'xs' ? 10 : 14} strokeWidth={3} />
      <span>{config.label}</span>
    </div>
  );
};

export default FanLoyaltyBadge;
